import { useEffect, useState } from 'react';
import {
  COOKIE_CHANGE_EVENT,
  removeCookie,
} from '@unified-checkout/kit-components';
import { getUserData } from '../utils';
import { IProfile } from '../types';
import { isBefore } from 'date-fns';

const cookiesSessionExpirationHandler = (): boolean | undefined => {
  const account = getUserData();
  const sessionTokenExpirationDate = account.sessionToken?.expirationDate;
  if (!sessionTokenExpirationDate) return undefined;
  const isSessionExpired = isBefore(
    new Date(sessionTokenExpirationDate || ''),
    new Date()
  );
  return isSessionExpired;
};

export const useIsUser = (): { isUser: boolean; userData?: IProfile } => {
  const [isUser, setIsUser] = useState<boolean>(
    cookiesSessionExpirationHandler() === false ? true : false
  );
  const [userData, setUserData] = useState<IProfile | undefined>(getUserData());
  
  useEffect(() => {
    const onCookieChange = (event: Event) => {
      const customEvent = event as CustomEvent<{ name?: string }>;
      if (customEvent.detail?.name === 'fastCheckoutAccount') {
        const isSessionExpired = cookiesSessionExpirationHandler();
        setIsUser(isSessionExpired  === false ? true : false);
        if (isSessionExpired === true) {
          removeCookie('fastCheckoutAccount');
          return setUserData(undefined);
        }
        const cookiesData = getUserData();
        setUserData(cookiesData);
      }
    };

    window.addEventListener(COOKIE_CHANGE_EVENT, onCookieChange);

    return () => {
      window.removeEventListener(COOKIE_CHANGE_EVENT, onCookieChange);
    };
  }, []);

  return { isUser, userData };
};
